const ACCESS_TOKEN_KEY = 'app.auth.accessToken'
const REFRESH_TOKEN_KEY = 'app.auth.refreshToken'

export interface TokenPair {
  accessToken: string
  refreshToken: string
}

/**
 * Token storage the request interceptor and refresh flow read from. Swap the
 * implementation without touching the rest of the API layer.
 */
export const tokenStorage = {
  getAccessToken: (): string | null => localStorage.getItem(ACCESS_TOKEN_KEY),
  getRefreshToken: (): string | null => localStorage.getItem(REFRESH_TOKEN_KEY),
  set: ({ accessToken, refreshToken }: TokenPair): void => {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
  },
  clear: (): void => {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
  },
}

export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized'

/**
 * Fired by the response interceptor when a request ends up unauthorized and
 * the session could not be refreshed. The AuthProvider listens and clears
 * the local session:
 *
 *   authEvents.addEventListener(AUTH_UNAUTHORIZED_EVENT, () => { ... })
 */
export const authEvents = new EventTarget()
